/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Custom hook to access customer profile data from checkout context
 */
import { useContext } from 'react';
import { CheckoutContext } from '@/components/checkout/utils/checkout-context-types';

export function useCustomerProfile() {
    const context = useContext(CheckoutContext);
    if (!context) {
        throw new Error('useCustomerProfile must be used within a CheckoutProvider');
    }
    return context.customerProfile;
}
